
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M249.1 1.8c-7.7 3.9-9 8.6-9.1 31.4V50h-3.7c-11.4 0-39 6.5-55.4 13-29.2 11.7-52.1 27-73.9 49.6-16.2 16.7-26.2 30.8-36.3 50.9-11.8 23.7-16.1 38.9-21.3 74.2l-.5 3.3H29.6c-18.4 0-19.5.1-22.6 2.2-9.1 6.3-9.1 19.3 0 25.5 3.1 2.2 4.2 2.3 22.6 2.3h19.3l.5 3.3c5.2 35.3 9.5 50.5 21.3 74.2 10.8 21.5 23.2 38.3 41.4 56 25.7 24.9 54.6 41.6 88.9 51.2 10 2.7 29.6 6.3 35 6.3h3.8l.4 19.2c.3 17.1.5 19.7 2.3 22.7 4.4 7.5 12.7 10.1 20.2 6.3 7.3-3.8 7.7-5.1 8.3-27.7l.5-20 7.5-.7c11.8-1.2 30.8-5.5 43.7-9.9 63.8-21.9 113.2-73.7 131.9-138.2 3.1-10.8 6.9-30.1 7.6-38.7l.3-3.5 20-.5c18.7-.5 20.2-.6 23.1-2.7 8.3-5.9 8.3-18.6 0-24.8-2.5-1.8-4.6-2-22.9-2.5l-20.2-.5-.3-3.5c-.1-1.9-1.2-8.8-2.2-15.2-12.8-75.6-66.3-138.1-139-162.2-14.4-4.8-29.8-8.2-42-9.4l-7.5-.7-.5-20c-.6-22.5-1-23.9-8.1-27.6-4.7-2.4-9.4-2.4-13.8-.1m36.4 80.3c67.5 11.3 123.9 62.5 140.9 128 4.7 18.3 5.9 29.6 5.3 50.9-.6 22-2.3 31.9-8.7 51.1C397.7 388.3 322.9 438 242.8 432c-24-1.9-44.1-7.5-66.3-18.6-34.8-17.3-63.1-46.2-80-81.6-23-48.6-23-103.2 0-151.6 12.9-26.9 33.2-51.1 57.5-68.4 10.9-7.7 31.5-18.4 44.1-22.7 27.7-9.5 58.1-12 87.4-7"}}),_c('path',{attrs:{"d":"M236 155.5c-21.8 4.9-38.8 14.3-53.7 29.8-9.1 9.6-14 16.6-19.4 28.2-12.3 26.2-12.3 58.8 0 85 5.4 11.6 10.3 18.6 19.4 28.2 12.9 13.5 27.4 22.3 46.2 27.9 8.3 2.6 10.3 2.8 27 2.8 15.4 0 19.1-.3 25.7-2.1 18.9-5.3 33.3-13.7 46.9-27.2 13.3-13.4 21.6-27.6 26.7-45.9 2.4-8.7 2.7-11.3 2.7-26.2s-.3-17.4-2.8-26.4c-10-36-37.2-63-73.5-72.8-10.2-2.7-35.6-3.5-45.2-1.3"}})])
          )
        }
      }
    